import clsx from "clsx";
import shape from "../../assets/img/shapes/border-shape-01.webp";


const BorderShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-border-shape-01", props.className)}>
            <img src={shape} alt="rmdr-border-shape-01" loading="lazy" width={465} height={518} />
        </div>
    )

}

export default BorderShape01;
